import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";

import { socket } from "../../../utils/socket";

import Logout from "../../../common/Logout";
import AppNotifPermPrompt from "../../settings/notification/components/AppNotifPermPrompt";
import { FaDesktop } from "react-icons/fa";
import { SetUserDetails } from "../../../redux/v2/user/actions";
import CustomSlider from "../../../common/CustomSlider";

function SuccessPage({ user, SetUserDetails }) {
    const navigate = useNavigate();

    const platform = localStorage.getItem("indi-platform");

    const ListenNativeInteraction = (id) => {
        socket.on(`app-native-component-response-${id}`, async (data) => {
            if (data.action == "INTERACT_NATIVE") {
                if (data.data.type == "notification") {
                    navigate("/home");
                }
            }
        });
    };

    useEffect(() => {
        if (user?.id) {
            localStorage.setItem("requirement_status", 3);
            SetUserDetails({
                ...user,
                requirement_status: 3,
            });

            if (localStorage.getItem("access-token") && user?.id) {
                ListenNativeInteraction(user?.id);
            }
        }

        return () => {
            socket.removeAllListeners(`app-native-component-response-${user?.id}`);
        };
    }, [user?.id]);

    return platform && platform != "null" ? (
        <>
            <div id="onb-v2-programs" className="onb-success-page">
                <AppNotifPermPrompt
                    type="onboarding"
                    closeSlider={() => {
                        navigate("/home");
                        localStorage.setItem("requirement_status", 3);
                    }}
                />

                <CustomSlider show={() => {}} setShowSlider={true}>
                    <AppNotifPermPrompt
                        type="onboarding"
                        closeSlider={() => {
                            navigate("/home");
                            localStorage.setItem("requirement_status", 3);
                        }}
                    />
                </CustomSlider>
            </div>
        </>
    ) : (
        <>
            <div id="onb-v2-programs" className="onb-success-page">
                <Logout showLogo showLogout={false} />
                <div id="onb-sp-content">
                    <h3>Program Added!</h3>

                    <p>Continue on your browser to enjoy indi on your computer, or download the app.</p>
                </div>

                <div id="onb-sp-links">
                    <div className="apple-google-app-links">
                        <>
                            <a target="_blank" href="https://apps.apple.com/us/app/indi-get-moving/id6444163742">
                                <img src="/assets/images/appstore.png" />
                            </a>

                            <a target="_blank" href="https://play.google.com/store/apps/details?id=com.indimoves.indi">
                                <img src="/assets/images/googleplay.png" />
                            </a>

                            <a
                                target="_blank"
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    // navigate("/home");
                                    navigate("/choose-plan");
                                    localStorage.setItem("requirement_status", 3);
                                }}
                            >
                                <div className="cont-browser-link">
                                    <FaDesktop />
                                    <div>
                                        <span>CONTINUE ON</span>
                                        <p>BROWSER</p>
                                    </div>
                                </div>
                            </a>
                        </>
                    </div>
                </div>
            </div>
        </>
    );
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {
    SetUserDetails,
})(SuccessPage);
